module.exports = __webpack_public_path__ + "static/media/banner-rewards.6cf7436a.png";